import * as CONSTANTS from '@/utils/constants/route-constants'
import type { RouteRecordRaw } from 'vue-router'

async function isEnvDevOrLocal(to: any, from: any, next: any) {
  if (process.env.NODE_ENV === 'development' || window.location.origin.includes('localhost')) {
    next()
  } else {
    next(false)
  }
}

export const navigationRoutes: RouteRecordRaw[] = [
  // {
  // 	name: CONSTANTS.JOBS_URL_NAME,
  // 	path: CONSTANTS.JOBS_URL,
  // 	children: [
  // 		{
  // 			name: `${CONSTANTS.JOBS_URL_NAME} `,
  // 			path: CONSTANTS.JOBS_URL,
  // 			alias: '/',
  // 			component: () => import('@/views/jobs/JobsView.vue'),
  // 		},
  // 		{
  // 			name: CONSTANTS.JOB_SCHEDULES_URL_NAME,
  // 			path: CONSTANTS.JOB_SCHEDULES_URL,
  // 			component: () => import('@/views/job-schedules/JobSchedulesView.vue'),
  // 		},
  // 	]
  // },
  {
    name: CONSTANTS.JOBS_URL_NAME,
    path: CONSTANTS.JOBS_URL,
    alias: '/',
    component: () => import('@/views/jobs/JobsView.vue')
  },

  // {
  //   name: CONSTANTS.JOB_SCHEDULES_URL_NAME,
  //   path: CONSTANTS.JOB_SCHEDULES_URL,
  //   component: () => import('@/views/job-schedules/JobSchedulesView.vue')
  // },
  {
    name: CONSTANTS.TEMPLATES_URL_NAME,
    path: CONSTANTS.TEMPLATES_URL,
    component: () => import('@/views/task-templates/TaskTemplatesView.vue')
  },
  {
    name: CONSTANTS.MAINTENANCE_URL_NAME,
    path: CONSTANTS.MAINTENANCE_URL,
    children: [
      {
        name: CONSTANTS.INSPECTIONS_URL_NAME,
        path: CONSTANTS.INSPECTIONS_URL,
        component: () => import('@/views/inspections/InspectionsView.vue')
      },
      // {
      //   name: CONSTANTS.INSPECTION_SCHEDULES_URL_NAME,
      //   path: CONSTANTS.INSPECTION_SCHEDULES_URL,
      //   component: () => import('@/views/inspection-schedules/InspectionSchedulesView.vue')
      // },
      {
        name: CONSTANTS.ISSUES_URL_NAME,
        path: CONSTANTS.ISSUES_URL,
        component: () => import('@/views/issues/IssuesView.vue')
      },
      {
        name: CONSTANTS.SERVICES_URL_NAME,
        path: CONSTANTS.SERVICES_URL,
        component: () => import('@/views/services/ServicesView.vue')
      },
      // {
      //   name: CONSTANTS.SERVICE_PROGRAMMES_URL_NAME,
      //   path: CONSTANTS.SERVICE_PROGRAMMES_URL,
      //   component: () => import('@/views/service-programmes/ServiceProgrammesView.vue')
      // },
      {
        name: CONSTANTS.SERVICE_TASKS_URL_NAME,
        path: CONSTANTS.SERVICE_TASKS_URL,
        component: () => import('@/views/service-tasks/ServiceTasksView.vue')
      }
    ]
  },
  {
    name: CONSTANTS.PURCHASE_URL_NAME,
    path: CONSTANTS.PURCHASE_URL,
    children: [
      {
        name: CONSTANTS.WORK_ORDERS_URL_NAME,
        path: CONSTANTS.WORK_ORDERS_URL,
        component: () => import('@/views/work-orders/WorkOrdersView.vue')
      },
      // {
      //   name: CONSTANTS.ORDER_SCHEDULES_URL_NAME,
      //   path: CONSTANTS.ORDER_SCHEDULES_URL,
      //   component: () => import('@/views/order-schedules/OrderSchedulesView.vue')
      // },
      // {
      //   name: CONSTANTS.MILL_ORDERS_URL_NAME,
      //   path: CONSTANTS.MILL_ORDERS_URL,
      //   component: () => import('@/views/mill-orders/MillOrdersView.vue')
      // },
      {
        name: CONSTANTS.VENDORS_URL_NAME,
        path: CONSTANTS.VENDORS_URL,
        component: () => import('@/views/vendors/VendorsView.vue')
      }
    ]
  },
  // {
  //   name: CONSTANTS.INSPECTIONS_URL_NAME,
  //   path: CONSTANTS.INSPECTIONS_URL,
  //   component: () => import('@/views/inspections/InspectionsView.vue')
  // },
  // {
  //   name: CONSTANTS.ISSUES_URL_NAME,
  //   path: CONSTANTS.ISSUES_URL,
  //   component: () => import('@/views/issues/IssuesView.vue')
  // },
  {
    name: CONSTANTS.VEHICLES_URL_NAME,
    path: CONSTANTS.VEHICLES_URL,
    component: () => import('../views/vehicles/VehiclesView.vue')
  },
  {
    name: CONSTANTS.MACHINE_URL_NAME,
    path: CONSTANTS.MACHINE_URL,
    component: () => import('../views/machine/MachineView.vue')
  },
  {
    name: CONSTANTS.EQUIPMENTS_URL_NAME,
    path: CONSTANTS.EQUIPMENTS_URL,
    component: () => import('../views/equipments/EquipmentsView.vue')
  },
  {
    name: CONSTANTS.EMPLOYEES_URL_NAME,
    path: CONSTANTS.EMPLOYEES_URL,
    component: () => import('@/views/employees/EmployeesView.vue')
  }
]

const routes: Array<RouteRecordRaw> = [
  ...navigationRoutes,
  {
    path: CONSTANTS.JOB_ADD_URL,
    name: CONSTANTS.JOB_ADD_URL_NAME,
    component: () => import('@/views/jobs/JobsAddView.vue')
  },
  {
    path: CONSTANTS.JOB_EDIT_URL,
    name: CONSTANTS.JOB_EDIT_URL_NAME,
    component: () => import('@/views/jobs/JobsEditView.vue')
  },
  // {
  //   path: CONSTANTS.JOB_SCHEDULES_ADD_URL,
  //   name: CONSTANTS.JOB_SCHEDULES_ADD_URL_NAME,
  //   component: () => import('@/views/job-schedules/JobScheduleAddView.vue')
  // },
  // {
  //   path: CONSTANTS.JOB_SCHEDULES_EDIT_URL,
  //   name: CONSTANTS.JOB_SCHEDULES_EDIT_URL_NAME,
  //   component: () => import('@/views/job-schedules/JobScheduleEditView.vue')
  // },
  {
    path: CONSTANTS.JOB_CHECKLIST_URL,
    name: CONSTANTS.JOB_CHECKLIST_NAME,
    component: () => import('@/views/ChecklistView.vue')
  },
  {
    path: CONSTANTS.JOB_DETAILS_URL,
    name: CONSTANTS.JOB_DETAILS_URL_NAME,
    component: () => import('@/views/jobs/JobsDetailsView.vue')
  },
  {
    path: CONSTANTS.TEMPLATE_ADD_URL,
    name: CONSTANTS.TEMPLATE_ADD_URL_NAME,
    component: () => import('@/views/task-templates/TaskTemplateAddView.vue')
  },
  {
    path: CONSTANTS.TEMPLATE_EDIT_URL,
    name: CONSTANTS.TEMPLATE_EDIT_URL_NAME,
    component: () => import('@/views/task-templates/TaskTemplateEditView.vue')
  },
  {
    path: CONSTANTS.VEHICLE_ADD_URL,
    name: CONSTANTS.VEHICLE_ADD_URL_NAME,
    component: () => import('@/views/vehicles/VehicleAddView.vue')
  },
  {
    path: CONSTANTS.VEHICLE_EDIT_URL,
    name: CONSTANTS.VEHICLE_EDIT_URL_NAME,
    component: () => import('@/views/vehicles/VehicleEditView.vue')
  },
  {
    path: CONSTANTS.VEHICLE_DETAILS_URL,
    name: CONSTANTS.VEHICLE_DETAILS_URL_NAME,
    component: () => import('@/views/vehicles/VehicleDetailsView.vue')
  },
  {
    path: CONSTANTS.MACHINE_ADD_URL,
    name: CONSTANTS.MACHINE_ADD_URL_NAME,
    component: () => import('@/views/machine/MachineAddView.vue')
  },
  {
    path: CONSTANTS.MACHINE_EDIT_URL,
    name: CONSTANTS.MACHINE_EDIT_URL_NAME,
    component: () => import('@/views/machine/MachineEditView.vue')
  },
  {
    path: CONSTANTS.MACHINE_DETAILS_URL,
    name: CONSTANTS.MACHINE_DETAILS_URL_NAME,
    component: () => import('@/views/machine/MachineDetailsView.vue')
  },
  {
    path: CONSTANTS.EQUIPMENTS_ADD_URL,
    name: CONSTANTS.EQUIPMENTS_ADD_URL_NAME,
    component: () => import('@/views/equipments/EquipmentAddView.vue')
  },
  {
    path: CONSTANTS.EQUIPMENTS_EDIT_URL,
    name: CONSTANTS.EQUIPMENTS_EDIT_URL_NAME,
    component: () => import('@/views/equipments/EquipmentEditView.vue')
  },
  {
    path: CONSTANTS.EQUIPMENTS_DETAILS_URL,
    name: CONSTANTS.EQUIPMENTS_DETAILS_URL_NAME,
    component: () => import('@/views/equipments/EquipmentDetailsView.vue')
  },
  {
    path: CONSTANTS.WORK_ORDER_ADD_URL,
    name: CONSTANTS.WORK_ORDER_ADD_URL_NAME,
    component: () => import('@/views/work-orders/WorkOrderAddView.vue')
  },
  {
    path: CONSTANTS.WORK_ORDER_EDIT_URL,
    name: CONSTANTS.WORK_ORDER_EDIT_URL_NAME,
    component: () => import('@/views/work-orders/WorkOrderEditView.vue')
  },
  {
    path: CONSTANTS.ORDER_DETAILS_URL,
    name: CONSTANTS.ORDER_DETAILS_URL_NAME,
    component: () => import('@/views/jobs/JobsDetailsView.vue')
  },
  {
    path: CONSTANTS.MILL_ORDER_DETAILS_URL,
    name: CONSTANTS.MILL_ORDER_DETAILS_URL_NAME,
    component: () => import('@/views/jobs/JobsDetailsView.vue')
  },
  {
    path: CONSTANTS.MILL_ORDER_ADD_URL,
    name: CONSTANTS.MILL_ORDER_ADD_URL_NAME,
    component: () => import('@/views/mill-orders/MillOrderAddView.vue')
  },
  {
    path: CONSTANTS.MILL_ORDER_EDIT_URL,
    name: CONSTANTS.MILL_ORDER_EDIT_URL_NAME,
    component: () => import('@/views/mill-orders/MillOrderEditView.vue')
  },
  // {
  //   path: CONSTANTS.ORDER_SCHEDULE_ADD_URL,
  //   name: CONSTANTS.ORDER_SCHEDULE_ADD_URL_NAME,
  //   component: () => import('@/views/order-schedules/OrderScheduleAddView.vue')
  // },
  // {
  //   path: CONSTANTS.ORDER_SCHEDULE_EDIT_URL,
  //   name: CONSTANTS.ORDER_SCHEDULE_EDIT_URL_NAME,
  //   component: () => import('@/views/order-schedules/OrderScheduleEditView.vue')
  // },
  {
    path: CONSTANTS.SERVICE_ADD_URL,
    name: CONSTANTS.SERVICE_ADD_URL_NAME,
    component: () => import('@/views/services/ServiceAddView.vue')
  },
  {
    path: CONSTANTS.SERVICE_EDIT_URL,
    name: CONSTANTS.SERVICE_EDIT_URL_NAME,
    component: () => import('@/views/services/ServiceEditView.vue')
  },
  {
    path: CONSTANTS.SERVICE_DETAILS_URL,
    name: CONSTANTS.SERVICE_DETAILS_URL_NAME,
    component: () => import('@/views/jobs/JobsDetailsView.vue')
  },
  // {
  //   path: CONSTANTS.SERVICE_PROGRAMME_ADD_URL,
  //   name: CONSTANTS.SERVICE_PROGRAMME_ADD_URL_NAME,
  //   component: () => import('@/views/service-programmes/ServiceProgrammeAddView.vue')
  // },
  // {
  //   path: CONSTANTS.SERVICE_PROGRAMME_EDIT_URL,
  //   name: CONSTANTS.SERVICE_PROGRAMME_EDIT_URL_NAME,
  //   component: () => import('@/views/service-programmes/ServiceProgrammeEditView.vue')
  // },
  {
    path: CONSTANTS.SERVICE_TASK_ADD_URL,
    name: CONSTANTS.SERVICE_TASK_ADD_URL_NAME,
    component: () => import('@/views/service-tasks/ServiceTaskAddView.vue')
  },
  {
    path: CONSTANTS.SERVICE_TASK_EDIT_URL,
    name: CONSTANTS.SERVICE_TASK_EDIT_URL_NAME,
    component: () => import('@/views/service-tasks/ServiceTaskEditView.vue')
  },
  {
    path: CONSTANTS.INSPECTION_ADD_URL,
    name: CONSTANTS.INSPECTION_ADD_URL_NAME,
    component: () => import('@/views/inspections/InspectionAddView.vue')
  },
  {
    path: CONSTANTS.INSPECTION_EDIT_URL,
    name: CONSTANTS.INSPECTION_EDIT_URL_NAME,
    component: () => import('@/views/inspections/InspectionEditView.vue')
  },
  {
    path: CONSTANTS.INSPECTION_DETAILS_URL,
    name: CONSTANTS.INSPECTION_DETAILS_URL_NAME,
    component: () => import('@/views/jobs/JobsDetailsView.vue')
  },
  // {
  //   path: CONSTANTS.INSPECTION_SCHEDULE_ADD_URL,
  //   name: CONSTANTS.INSPECTION_SCHEDULE_ADD_URL_NAME,
  //   component: () => import('@/views/inspection-schedules/InspectionScheduleAddView.vue')
  // },
  // {
  //   path: CONSTANTS.INSPECTION_SCHEDULE_EDIT_URL,
  //   name: CONSTANTS.INSPECTION_SCHEDULE_EDIT_URL_NAME,
  //   component: () => import('@/views/inspection-schedules/InspectionScheduleEditView.vue')
  // },
  {
    path: CONSTANTS.ISSUE_ADD_URL,
    name: CONSTANTS.ISSUE_ADD_URL_NAME,
    component: () => import('@/views/issues/IssueAddView.vue')
  },
  {
    path: CONSTANTS.ISSUE_EDIT_URL,
    name: CONSTANTS.ISSUE_EDIT_URL_NAME,
    component: () => import('@/views/issues/IssueEditView.vue')
  },
  {
    path: CONSTANTS.ISSUE_DETAILS_URL,
    name: CONSTANTS.ISSUE_DETAILS_URL_NAME,
    component: () => import('@/views/jobs/JobsDetailsView.vue')
  },
  {
    path: CONSTANTS.VENDORS_URL,
    name: CONSTANTS.VENDORS_URL_NAME,
    component: () => import('@/views/vendors/VendorsView.vue')
  },
  {
    path: CONSTANTS.VENDORS_ADD_URL,
    name: CONSTANTS.VENDORS_ADD_URL_NAME,
    component: () => import('@/views/vendors/VendorsAddView.vue')
  },
  {
    path: CONSTANTS.VENDORS_EDIT_URL,
    name: CONSTANTS.VENDORS_EDIT_URL_NAME,
    component: () => import('@/views/vendors/VendorsEditView.vue')
  },
  {
    path: CONSTANTS.EMPLOYEE_ADD_URL,
    name: CONSTANTS.EMPLOYEE_ADD_URL_NAME,
    component: () => import('@/views/employees/EmployeeAddView.vue')
  },
  {
    path: CONSTANTS.EMPLOYEE_EDIT_URL,
    name: CONSTANTS.EMPLOYEE_EDIT_URL_NAME,
    component: () => import('@/views/employees/EmployeeEditView.vue')
  },
  {
    path: CONSTANTS.LOGIN_URL,
    name: CONSTANTS.LOGIN_URL_NAME,
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: CONSTANTS.RESET_PASSWORD_URL,
    name: CONSTANTS.RESET_PASSWORD_URL_NAME,
    component: () => import('@/views/ResetPasswordView.vue')
  },
  {
    path: CONSTANTS.SET_PASSWORD_URL,
    name: CONSTANTS.SET_PASSWORD_URL_NAME,
    component: () => import('@/views/ResetPasswordView.vue')
  },
  {
    path: '/errors',
    name: 'Errors',
    component: () => import('@/views/ErrorsView.vue'),
    beforeEnter: isEnvDevOrLocal
  }
]

export default routes
